import { Dispatch, SetStateAction } from "react";
import api from "../utils/api";

export const handleDeleteItem = async (
  url: string,
  setIsAlertOpen: (isOpen: boolean) => void,
  idItem: number,
  addToast: (options: {
    title: string;
    description: string;
    status: "success" | "error";
  }) => void,
  setIsLoaded: Dispatch<SetStateAction<boolean>>,
) => {
  try {
    setIsLoaded(false);
    const response = await api.delete(`${url}/${idItem}`);
    if (response.status === 200 || response.status === 204) {
      addToast({
        title: "Sucesso",
        description: "Item eliminado",
        status: "success",
      });
      setIsAlertOpen(false);
    } else {
      throw new Error();
    }
  } catch (error) {
    console.error("API Error:", error);
    addToast({
      status: "error",
      title: "Erro",
      description: "Ocorreu um erro ao eliminar o item",
    });
  }
  setIsLoaded(true);
};
